import { MomentInput } from 'moment'
import offsetDate from './offset-date-to-utc'

function formatDate(date?: MomentInput): string {
  return date ? offsetDate(date).format('YYYY-MM-DD') : ''
}

export default formatDate
